import { render, staticRenderFns } from "./SupplierName.vue?vue&type=template&id=79f7f4b3&"
import script from "./SupplierName.vue?vue&type=script&lang=js&"
export * from "./SupplierName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports